import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { SeoService } from 'src/app/services/seo.service';
import { Meta } from '@angular/platform-browser';
import { ExclusionsListService } from 'src/app/services/exclusions-list.service';
import { ExclusionList } from 'src/app/models/exclusion-list';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { Subscription } from 'rxjs';
import { SafePipe } from 'src/app/pipes/safe.pipe';
import { ChartEmbedComponent } from '../_components/chart-embed/chart-embed.component';
import { PortfolioBallsNavigationComponent } from "./_components/portfolio-balls-navigation/portfolio-balls-navigation.component";
import { SvgSpritesComponent } from "../_components/svg-sprites/svg-sprites.component";
import { SvgDefinitionsComponent } from "../_components/svg-definitions/svg-definitions.component";

@Component({
    selector: 'app-portfolios',
    templateUrl: './portfolios.component.html',
    styleUrls: ['./portfolios.component.scss'],
    providers: [ExclusionsListService],
    imports: [CommonModule, SafePipe, ChartEmbedComponent, SvgSpritesComponent,  SvgDefinitionsComponent]
})
export class PortfoliosComponent implements OnInit {

  subscriptions:Array<Subscription> = [];
  title = "Investing for Catholics Index Portfolios.";
  portfolio = 50;

  Sprites=[10,  20,  30,  40,  50,  60,  70,  80, 90, 100]

  exclusions: ExclusionList[]|any;

  imageSrc = 'images/portfolios/50.png';
  imageSrc2 = 'images/portfolios/50w.png';
  messageText = '';
  imageButtons = [ 
    {src:'images/portfolios/10.png'}, 
    {src:'images/portfolios/20.png'}, 
    {src:'images/portfolios/30.png'}
  ]

  // imageButton(s) {
  //   this.imageSrc = "images/portfolios/"+s+".png"
  //   this.imageSrc2 = "images/portfolios/"+s+"w.png"
    
  // }

  constructor(private seoservice: SeoService, private meta: Meta, private exlusionservice: ExclusionsListService, private route: ActivatedRoute, @Inject(PLATFORM_ID) private platformId: Object) {

    this.exlusionservice.getExclusionsList().subscribe(resp => {
   
      //removes first article from header
      this.exclusions = resp;
   
    })
// $&(this.exclusions)

   }

  ngOnInit() {

    this.route.params.subscribe(resp => {
// $&("resp.queryParams", resp)

      if(resp && resp.portfolioNumber){
        var portNumber = Number(resp.portfolioNumber)

        if (this.Sprites.indexOf(portNumber) > -1) {
// $&("Port Number Found In Sprites", portNumber)
          //this.imageButton(portNumber);
          this.portfolio = portNumber;
        } else {
// $&("Port Number Not Found In Sprites", portNumber)
        }
      }
      // resp.queryParams
    })

    this.seoservice.updateTitle(this.title);
  	this.meta.addTag({name: 'keywords', content: 'ifc index portfolios, risk-appropriate index portfolios, Risk-Based Index Portfolios'});
    this.meta.addTag({name: 'description', content: 'Investing for Catholics Index Portfolios.'});
    this.meta.addTag({name: 'author', content: 'Investing for Catholics (IFC)'});
    this.meta.addTag({name: 'robots', content: 'index, follow'});

  }

  onClick(imageNameObjectL:any) {
    this.imageSrc = imageNameObjectL.src;
  }
  ngAfterViewInit(){
    if (isPlatformBrowser(this.platformId)) {
      window.addEventListener('message', this.receiveMessage.bind(this));  
    }
  }
  ngOnDestroy(): void {
    this.subscriptions.forEach(x=>x.unsubscribe());
    if (isPlatformBrowser(this.platformId)) {
      window.removeEventListener('message', this.receiveMessage.bind(this));  
    }
  }
  private receiveMessage(event: MessageEvent): void {  
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    let iframes = document.getElementsByTagName("iframe");
    console.log("PAGE receiveMessage",event.data, iframes.length)
    if(iframes!=null){
      for(let i=0;i<iframes.length;i++){
        iframes[i]?.contentWindow?.postMessage(event.data, '*');
      }
    }
  }

  goToPortfolio(portfolioNumber:number){
    window.open("/portfolios/"+portfolioNumber.toString(), "_blank");
  }

}
